export enum COLLABORATOR_STATUS {
  ADMINISTRATOR = 'ADMINISTRATOR',
  EMPLOYEE = 'EMPLOYEE'
}

export enum COLLABORATOR_TYPE {
  INVITATION = 'INVITATION',
  EMPLOYEE = 'EMPLOYEE'
}

export enum COLLABORATOR_TABS {
  MEMBERS = 'members',
  DOMAINS = 'domains'
}

export enum COLLABORATOR_FILTER_TYPE {
  ALL = 'all',
  EMPLOYEES = 'employees',
  INVITATIONS = 'invitations'
}
